export const footerBrandName: string = 'LVBET.COM';
